import { render, staticRenderFns } from "./tableDetail.vue?vue&type=template&id=7913be41&scoped=true"
var script = {}
import style0 from "./tableDetail.vue?vue&type=style&index=0&id=7913be41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7913be41",
  null
  
)

export default component.exports